module.exports = __webpack_public_path__ + "assets/img/496b34802df203b7284cbe9c57d897c5.svg";